//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Message } from 'element-ui'
import area from'./address.js'
export default {
    data() {
        return {
            provincial:'',
            provincialList:[],
            city:'',
            cityList:[],
            district:'',
            districtList:[],
            purchasingStatus:'选择业务经理',
            purchasingStatusList:[],
            areaData:area,
            shopAddress:'',
            contacts:'',
            linkman:'',
            shopPhone:'',
            shopName:'',
            res:{provincial: '四川省',provincialId: -1,city: '成都市',cityId: -1,district: '',districtId:''}
        }
    },
    created(){
        this.info()
    },
    methods: {
        info(){
            let data = {
                pageNo:1,
                pageSize:1,
                shopType:1,
                dealerId:window.sessionStorage.getItem('dealerId')
            }
            // 加载业务经理列表
            this.$axios.post('/mtea/stock/dealer/indexSearch', data).then(res => {
                if(res.staffs.length === 0){
                    this.$message('请先到人员管理中添加业务经理！');
                }
                this.purchasingStatusList = res.staffs
                this.purchasingStatusList.unshift({dStaffId:'选择业务经理',dStaffName:'选择业务经理'})
            })
            console.log(this.res)
            for(let i = 0;i<this.areaData.length;i++){
                if(this.areaData[i].TopID === 0){
                    this.provincialList.push(this.areaData[i]) 
                    if(this.areaData[i].AddName === this.res.provincial)
                    this.res.provincialId = this.areaData[i].ID
                }
                if(this.res.provincialId !== -1 && this.areaData[i].TopID === this.res.provincialId){
                    this.cityList.push(this.areaData[i])
                    if(this.areaData[i].AddName === this.res.city)
                    this.res.cityId = this.areaData[i].ID
                }
                if(this.res.cityId !== -1 && this.areaData[i].TopID === this.res.cityId)
                    this.districtList.push(this.areaData[i])
                if(this.areaData[i].AddName === this.res.district)
                    this.res.districtId = this.areaData[i].ID                    

            }
            this.provincial = this.res.provincialId
            this.city = this.res.cityId
            this.district = this.res.districtId
        },
        changeProvincial(ID){
            console.log(ID)
            this.city = ''
            this.cityList = []
            this.district = ''
            this.districtList = []
            for(let i = 0;i<this.areaData.length;i++){
                if(this.areaData[i].TopID === ID)
                this.cityList.push(this.areaData[i])
                if(this.areaData[i].TopID > ID) break
            } 
        },
        changeCity(ID){
            this.district = ''
            this.districtList = []
            for(let i = 0;i<this.areaData.length;i++){
                if(this.areaData[i].TopID === ID)
                this.districtList.push(this.areaData[i])
                if(this.areaData[i].TopID > ID) return
            } 
        },
        changeDistrict(ID){
            console.log(ID)
            this.districtList.forEach(e=>{
                if(e.ID === ID)
                this.res.district = e.AddName
            })
        },
        saveClick(){
            if(this.shopName === ''){
                this.$message('请输入店铺名！');
                return
            }
            if(this.purchasingStatus === '选择业务经理'){
                this.$message('请选择业务经理！');
                return
            }
            let data = {
                DShopProvince:this.res.provincial,
                DShopArea:this.res.district,
                DShopCity:this.res.city,
                DShopAddress:this.shopAddress,
                DShopLinkman:this.linkman,
                DShopName:this.shopName,
                DShopPhone:this.shopPhone,
                DStaffId:this.purchasingStatus,
                dealerId:window.sessionStorage.getItem('dealerId'),
            }
            console.log(data)
            this.$axios.post('/mtea/stock/dealer/addShop',data).then(()=>{
                this.$message({
                    message: '保存成功',
                    type: 'success'
                });
                this.$router.push({name:'homePage'})
            })
        }
    },
}
